/* ============================================================================
   Agualeve · PDP-Module
   Enthaelt: M5 Rechner · M6 Groessenauswahl · M8 Lieferdatum · M-Abo Kaufoption
   M1, M14, M15, M16 und M17 brauchen kein JavaScript.
   Einbinden ueber das Basis-Element:
     <script src="{{ 'pdp-module.js' | asset_url }}" defer></script>
   ============================================================================ */

if (!window.__pdpGeladen) {
  window.__pdpGeladen = true;

  /* ===== M5 · Volumen-Helfer + Saison-Rechner ===== */
  (function () {
    document.querySelectorAll('.pdp-calc').forEach(function (alt) {
      if (alt.dataset.readyV2) return;

      /* Eine aeltere Fassung von M5 kann die Box schon belegt haben. Ein Klon
         uebernimmt das Markup, aber keinen einzigen Event-Listener. */
      var box = alt;
      if (alt.dataset.ready) {
        var altFeld = alt.querySelector('#pdpCalcL');
        var wert = altFeld ? altFeld.value : '';
        box = alt.cloneNode(true);
        alt.replaceWith(box);
        var neuFeld = box.querySelector('#pdpCalcL');
        if (neuFeld) neuFeld.value = wert;
      }
      box.dataset.ready   = '1';
      box.dataset.readyV2 = '1';

      var start     = parseFloat(box.dataset.start) || 0;
      var erhalt    = parseFloat(box.dataset.erhalt) || 0;
      var intervall = parseInt(box.dataset.intervall, 10) || 3;
      var saison    = parseInt(box.dataset.saison, 10) || 28;

      var varianten = [];
      try { varianten = JSON.parse(box.dataset.varianten || '[]'); } catch (e) {}

      varianten.forEach(function (v) {
        if (!v.reichweite) {
          var m = String(v.titel).match(/([\d.,]+)\s*l\s*$/i);
          if (m) v.reichweite = parseInt(m[1].replace(/[.,]/g, ''), 10) || 0;
        }
      });

      var mitGramm = varianten.filter(function (v) { return v.gramm > 0; })
                              .sort(function (a, b) { return a.gramm - b.gramm; });
      var mitReich = varianten.filter(function (v) { return v.reichweite > 0; })
                              .sort(function (a, b) { return a.reichweite - b.reichweite; });

      var modus = (start > 0 && mitGramm.length) ? 'saison'
                : (mitReich.length > 1 ? 'groesse' : null);
      if (!modus) { box.style.display = 'none'; return; }

      var anwendungen = Math.max(0, Math.floor((saison - 1) / intervall));
      var input = box.querySelector('#pdpCalcL');
      var out   = function (k) { return box.querySelector('[data-o="' + k + '"]'); };
      var apply = out('apply'), pick = out('pick');
      var menge = 1, faktor = 1, lauf = 0;
      var mengeStart = 1, mengeSaison = 1;
      var aboLieferungen = parseInt(box.dataset.abolieferungen, 10) || 3;

      /* Der Rechner informiert nur noch. Die Menge setzt das Abo-Modul,
         abhaengig davon, welche Kaufoption der Kunde waehlt. */
      var saisonAboSinnvoll = true;
      function meldeMengen() {
        if (apply) apply.hidden = true;
        document.dispatchEvent(new CustomEvent('pdp:mengen', {
          detail: { start: mengeStart, saison: mengeSaison, saisonAbo: saisonAboSinnvoll }
        }));
      }
      function dosen(z) { return z === 1 ? 'eine Dose' : z + ' Dosen'; }

      if (modus === 'saison') out('saisonzeile').hidden = false;
      else out('titel').textContent = 'Welche Größe passt zu meinem Teich?';

      function g(v) {
        return v >= 1000
          ? (v / 1000).toFixed(v % 1000 === 0 ? 0 : 1).replace('.', ',') + ' kg'
          : Math.round(v) + ' g';
      }
      function eur(v) { return v.toFixed(2).replace('.', ',') + ' €'; }
      function n(v)   { return v.toLocaleString('de-DE'); }
      function norm(s){ return String(s == null ? '' : s).replace(/\s+/g, ' ').trim(); }

      function bez(v) {
        var t = norm(v.titel);
        if (!t || /^default\s*title$/i.test(t)) {
          return v.gramm ? g(v.gramm) : 'Packung';
        }
        return t;
      }

      function hauptForm() {
        var onv = document.querySelector('[option-name-value]');
        return (onv && onv.closest('form')) || document.querySelector('form[action*="/cart/add"]');
      }

      function qtyFeld() {
        var f = hauptForm();
        return (f && f.querySelector('input[name="quantity"]:not([type="hidden"])'))
            || document.querySelector('input[name="quantity"]:not([type="hidden"])');
      }

      function waehleVariante(v, fertig) {
        var t = norm(v.titel), kachel = null;

        document.querySelectorAll('[option-name-value]').forEach(function (el) {
          if (kachel || el.closest('.pdp-calc')) return;
          if (norm(el.getAttribute('option-name-value')) === t) kachel = el;
        });
        if (!kachel) { fertig(false); return; }

        var label = kachel.closest('label');
        var radio = label ? label.querySelector('input[type="radio"]') : null;
        if (radio && radio.checked) { fertig(true); return; }

        var klick = kachel.querySelector('[option-value]') || kachel;
        var form  = kachel.closest('form');
        var stopp = function (ev) { ev.preventDefault(); ev.stopImmediatePropagation(); };

        if (form) form.addEventListener('submit', stopp, true);
        try { klick.click(); } catch (e) {}

        setTimeout(function () {
          if (form) form.removeEventListener('submit', stopp, true);
          var ok = radio ? radio.checked : false;
          if (!ok && form) {
            var idf = form.querySelector('[name="id"]');
            ok = !!(idf && String(idf.value).trim() === String(v.id));
          }
          if (!ok) {
            var m = location.search.match(/[?&]variant=(\d+)/);
            ok = !!(m && m[1] === String(v.id));
          }
          fertig(ok);
        }, 260);
      }

      function zeigeFallback(v, liter) {
        if (!pick) return;
        var u = new URL(window.location.href);
        u.searchParams.set('variant', v.id);
        u.searchParams.set('teich', liter);
        pick.setAttribute('href', u.toString());
        pick.textContent = 'Größe ' + bez(v) + ' auswählen';
        pick.hidden = false;
      }

      function leerZustand() {
        out('fazit').textContent = 'Tragen Sie Ihr Teichvolumen ein – oder lassen Sie es unten ausrechnen.';
        out('notiz').textContent = '';
        if (modus === 'saison') {
          out('erst').textContent = '–';
          out('nach').textContent = '–';
          out('bedarf').textContent = '–';
          out('ivtext').textContent = 'Danach alle ' + intervall + ' Wochen';
        }
        if (pick)  pick.hidden = true;
        if (apply) apply.hidden = true;
      }

      function rechne(vomNutzer) {
        var roh = parseInt(input.value, 10);
        if (!roh || roh < 100) { leerZustand(); return; }

        var liter = roh;
        if (pick) pick.hidden = true;
        lauf++;
        var meinLauf = lauf, wahl, basisNotiz;

        if (modus === 'saison') {
          var erst   = liter / 1000 * start;
          var nach   = liter / 1000 * erhalt;
          var bedarf = erst + nach * anwendungen;

          /* Dose waehlen: die kleinste, die die Erstdosis traegt */
          wahl = null;
          for (var i = 0; i < mitGramm.length; i++) {
            if (mitGramm[i].gramm >= erst) { wahl = mitGramm[i]; break; }
          }
          if (!wahl) wahl = mitGramm[mitGramm.length - 1];

          mengeStart  = Math.max(1, Math.ceil(erst / wahl.gramm));
          mengeSaison = Math.max(mengeStart, Math.ceil(bedarf / wahl.gramm));
          menge = mengeStart;

          var aboGesamt = mengeStart * aboLieferungen * wahl.gramm;
          var ueber     = aboGesamt - bedarf;
          var anteil    = bedarf > 0 ? ueber / bedarf : 0;
          /* Drei Lieferungen lohnen sich nur, wenn der Ueberhang ertraeglich bleibt */
          saisonAboSinnvoll = (mengeSaison > 1) && (anteil <= 0.6);

          out('erst').textContent   = g(erst);
          out('ivtext').textContent = 'Danach alle ' + intervall + ' Wochen';
          out('nach').textContent   = g(nach);
          out('bedarf').textContent = 'ca. ' + g(bedarf);

          if (mengeSaison === 1) {
            out('fazit').textContent = 'Eine Dose reicht Ihnen die ganze Saison.';
            basisNotiz = 'Für ' + n(liter) + ' Liter brauchen Sie rund ' + g(bedarf)
                       + ' – die Dose (' + bez(wahl) + ') deckt das komplett ab.';
          } else {
            out('fazit').textContent = mengeStart === 1
              ? 'Für den Start genügt eine Dose.'
              : 'Für den Start genügen ' + mengeStart + ' Dosen.';
            basisNotiz = 'Ihre Erstdosis für ' + n(liter) + ' Liter sind ' + g(erst)
                       + (mengeStart === 1 ? ' – das ist genau eine Dose' : ' – das sind genau ' + mengeStart + ' Dosen')
                       + '. Über die Saison kommen rund ' + g(bedarf) + ' zusammen, also '
                       + dosen(mengeSaison) + '.';
            if (saisonAboSinnvoll && anteil > 0.25) {
              basisNotiz += ' Das Saison-Abo würde dabei ' + g(aboGesamt) + ' liefern – rund '
                          + g(ueber) + ' blieben für die nächste Saison übrig.';
            }
            basisNotiz += ' Wählen Sie unten, wie weit Sie vorausplanen möchten.';
          }
          meldeMengen();

        } else {
          wahl = null; var anzahl = 1;
          for (var j = 0; j < mitReich.length; j++) {
            if (mitReich[j].reichweite >= liter) { wahl = mitReich[j]; break; }
          }
          if (!wahl) { wahl = mitReich[mitReich.length - 1]; anzahl = Math.ceil(liter / wahl.reichweite); }
          menge = anzahl; mengeStart = anzahl; mengeSaison = anzahl;

          out('fazit').textContent = anzahl > 1
            ? 'Für ' + n(liter) + ' Liter brauchen Sie ' + anzahl + ' × ' + bez(wahl) + '.'
            : 'Für ' + n(liter) + ' Liter passt: ' + bez(wahl);

          basisNotiz = eur(wahl.preis * anzahl);

          if (wahl.reichweite) {
            var jeTausend = wahl.preis / (wahl.reichweite / 1000);
            basisNotiz += ' · ' + eur(jeTausend) + ' je 1.000 Liter Teichwasser';

            var kleinste = mitReich[0];
            if (kleinste && kleinste !== wahl && kleinste.reichweite) {
              var jeTausendKlein = kleinste.preis / (kleinste.reichweite / 1000);
              var ersparnis = Math.round((1 - jeTausend / jeTausendKlein) * 100);
              if (ersparnis >= 3) basisNotiz += ' – ' + ersparnis + ' % günstiger als die kleinste Größe';
            }
          }
          basisNotiz += '.';

          meldeMengen();
        }

        out('notiz').textContent = basisNotiz;
        document.dispatchEvent(new CustomEvent('pdp:empfehlung', { detail: { titel: wahl.titel } }));

        if (vomNutzer && varianten.length > 1) {
          waehleVariante(wahl, function (ok) {
            if (meinLauf !== lauf) return;
            if (ok) out('notiz').textContent = basisNotiz + ' Die Größe ist oben ausgewählt.';
            else zeigeFallback(wahl, liter);
          });
        }
      }

      var help = out('help'), ht = out('helptoggle'), helpOut = out('helpout');

      function dim(k) {
        var el = box.querySelector('[data-d="' + k + '"]');
        return el ? (parseFloat(String(el.value).replace(',', '.')) || 0) : 0;
      }

      function volumen() {
        var l = dim('l'), b = dim('b'), t = dim('t');
        if (!l || !b || !t) {
          helpOut.textContent = 'Maße in Metern eintragen – wir rechnen um. Zur Orientierung: 3 × 2 m mit 60 cm Tiefe sind rund 2.500 Liter.';
          return;
        }
        var liter = Math.max(100, Math.round(l * b * t * faktor * 1000 / 100) * 100);
        helpOut.textContent = 'Das sind rund ' + n(liter) + ' Liter. Im Zweifel lieber aufrunden.';
        input.value = liter;
        rechne(true);
      }

      if (ht && help) {
        ht.addEventListener('click', function () {
          help.hidden = !help.hidden;
          ht.textContent = help.hidden ? 'Volumen ausrechnen' : 'Schließen';
        });
      }

      box.querySelectorAll('[data-d]').forEach(function (el) { el.addEventListener('input', volumen); });
      box.querySelectorAll('.pdp-calc__shape button').forEach(function (b) {
        b.addEventListener('click', function () {
          box.querySelectorAll('.pdp-calc__shape button').forEach(function (x) { x.classList.remove('is-on'); });
          b.classList.add('is-on');
          faktor = parseFloat(b.dataset.f) || 1;
          volumen();
        });
      });

      input.addEventListener('input', function () { rechne(true); });

      var p = new URLSearchParams(window.location.search).get('teich');
      if (p && parseInt(p, 10) > 0) input.value = parseInt(p, 10);

      rechne(false);
    });
  })();

  /* ===== M6 · Groessenauswahl ===== */
  (function () {
    var wrap = document.querySelector('[data-pdp-sizes]');
    if (!wrap) return;

    var quelle = wrap.querySelector('script[type="application/json"]');
    var daten = [];
    try { daten = JSON.parse(quelle ? quelle.textContent : '[]'); } catch (e) { return; }
    if (daten.length < 2) { wrap.style.display = 'none'; return; }

    function norm(s){ return String(s == null ? '' : s).replace(/\s+/g, ' ').trim(); }
    function eur(v){ return v.toFixed(2).replace('.', ',') + ' €'; }
    function n(v){ return v.toLocaleString('de-DE'); }

    daten.forEach(function (v) {
      var t = norm(v.titel);
      v.kurz = norm(t.split(/\s[–-]\s/)[0]) || t;
      if (!v.reichweite) {
        var m = t.match(/([\d.,]+)\s*l\s*$/i);
        if (m) v.reichweite = parseInt(m[1].replace(/[.,]/g, ''), 10) || 0;
      }
    });

    var teuerste = 0;
    daten.forEach(function (v) { if (v.unit > teuerste) teuerste = v.unit; });

    function kachelFuer(titel) {
      var g = null;
      document.querySelectorAll('[option-name-value]').forEach(function (el) {
        if (g) return;
        if (norm(el.getAttribute('option-name-value')) === norm(titel)) g = el;
      });
      return g;
    }

    function aktiverTitel() {
      var t = null;
      document.querySelectorAll('[option-name-value]').forEach(function (el) {
        if (t) return;
        var lab = el.closest('label');
        var r = lab && lab.querySelector('input[type="radio"]');
        if (r && r.checked) t = norm(el.getAttribute('option-name-value'));
      });
      return t;
    }

    function waehle(titel, fertig) {
      var kachel = kachelFuer(titel);
      if (!kachel) { fertig(false); return; }

      var lab = kachel.closest('label');
      var radio = lab && lab.querySelector('input[type="radio"]');
      if (radio && radio.checked) { fertig(true); return; }

      var klick = kachel.querySelector('[option-value]') || kachel;
      var form = kachel.closest('form');
      var stopp = function (ev) { ev.preventDefault(); ev.stopImmediatePropagation(); };
      if (form) form.addEventListener('submit', stopp, true);
      try { klick.click(); } catch (e) {}

      setTimeout(function () {
        if (form) form.removeEventListener('submit', stopp, true);
        fertig(radio ? radio.checked : (norm(aktiverTitel()) === norm(titel)));
      }, 260);
    }

    var gitter = document.createElement('div');
    gitter.className = 'pdp-sizes__grid';
    wrap.appendChild(gitter);

    daten.forEach(function (v) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'pdp-size';
      b.setAttribute('data-titel', v.titel);

      var rabatt = (teuerste && v.unit && v.unit < teuerste)
        ? Math.round((1 - v.unit / teuerste) * 100) : 0;

      var meta = [];
      if (v.unit && v.einheit) meta.push(eur(v.unit) + ' / ' + v.einheit);
      if (v.reichweite) meta.push('bis ca. ' + n(v.reichweite) + ' l');

      var html = '';
      html += '<span class="pdp-size__tipp" hidden>Für Sie passend</span>';
      if (rabatt >= 3) html += '<span class="pdp-size__spar">– ' + rabatt + ' %</span>';
      html += '<span class="pdp-size__kurz">' + v.kurz + '</span>';
      html += '<span class="pdp-size__preis">' + eur(v.preis) + '</span>';
      if (meta.length) {
        html += '<span class="pdp-size__meta">'
              + meta.map(function (s) { return '<span class="pdp-size__m">' + s + '</span>'; }).join(' · ')
              + '</span>';
      }
      b.innerHTML = html;

      b.addEventListener('click', function () {
        waehle(v.titel, function (ok) {
          if (ok) markiere();
          else notausgang();
        });
      });

      gitter.appendChild(b);
    });

    var spalten = (daten.length % 3 === 0) ? 3 : 2;
    gitter.style.gridTemplateColumns = 'repeat(' + spalten + ', minmax(0, 1fr))';

    function markiere() {
      var akt = aktiverTitel();
      gitter.querySelectorAll('.pdp-size').forEach(function (b) {
        var an = norm(b.getAttribute('data-titel')) === akt;
        b.classList.toggle('is-active', an);
        b.setAttribute('aria-pressed', an ? 'true' : 'false');
      });
    }

    function empfehlung(titel) {
      gitter.querySelectorAll('.pdp-size__tipp').forEach(function (e) { e.hidden = true; });
      if (!titel) return;
      var b = gitter.querySelector('.pdp-size[data-titel="' + String(titel).replace(/"/g, '\\"') + '"]');
      if (b) b.querySelector('.pdp-size__tipp').hidden = false;
    }

    function notausgang() {
      document.querySelectorAll('.variant-inside').forEach(function (el) {
        el.classList.remove('pdp-orig-aus');
      });
      document.querySelectorAll('.pdp-leer').forEach(function (el) {
        el.classList.remove('pdp-leer');
      });
      wrap.classList.add('pdp-sizes--warnung');
    }

    /* Kacheln an die Stelle der Original-Auswahl schieben */
    var altHeim = wrap.parentElement;
    var orig = document.querySelector('.variant-inside');

    if (orig && orig.parentNode) {
      orig.parentNode.insertBefore(wrap, orig);
      orig.classList.add('pdp-orig-aus');

      var p = altHeim;
      while (p && p !== document.body && p.children.length === 0 && !norm(p.textContent)) {
        p.classList.add('pdp-leer');
        p = p.parentElement;
      }
    }

    document.addEventListener('change', function (ev) {
      if (ev.target && ev.target.type === 'radio') setTimeout(markiere, 60);
    }, true);

    document.addEventListener('pdp:empfehlung', function (ev) {
      empfehlung(ev.detail && ev.detail.titel);
    });

    markiere();
    setTimeout(markiere, 800);
  })();

  /* ===== M8 · Lieferdatum ===== */
  (function () {
    /* ---------- Konfiguration ---------- */
    var KONFIG = {
      cutoff:        '14:00',        // Annahmeschluss, Berliner Zeit
      lieferzeitMin: 1,              // Werktage bis Zustellung, früheste
      lieferzeitMax: 2,              // Werktage bis Zustellung, späteste
      versandtage:   [1,2,3,4,5],    // 0 = Sonntag … 6 = Samstag
      zustelltage:   [1,2,3,4,5,6],
      zusatzFrei:    ['12-24','12-31'] // MM-TT, jedes Jahr versandfrei
    };
    /* ----------------------------------- */

    var box = document.querySelector('[data-pdp-liefer]');
    if (!box) return;

    var WT = ['Sonntag','Montag','Dienstag','Mittwoch','Donnerstag','Freitag','Samstag'];
    var MO = ['Januar','Februar','März','April','Mai','Juni','Juli','August','September','Oktober','November','Dezember'];

    function plus(d, n) { var x = new Date(d.getTime()); x.setUTCDate(x.getUTCDate() + n); return x; }
    function iso(d) {
      return d.getUTCFullYear() + '-' +
        String(d.getUTCMonth() + 1).padStart(2, '0') + '-' +
        String(d.getUTCDate()).padStart(2, '0');
    }

    function ostersonntag(j) {
      var a = j % 19, b = Math.floor(j / 100), c = j % 100,
          d = Math.floor(b / 4), e = b % 4,
          f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3),
          h = (19 * a + b - d - g + 15) % 30,
          i = Math.floor(c / 4), k = c % 4,
          l = (32 + 2 * e + 2 * i - h - k) % 7,
          m = Math.floor((a + 11 * h + 22 * l) / 451),
          monat = Math.floor((h + l - 7 * m + 114) / 31),
          tag = ((h + l - 7 * m + 114) % 31) + 1;
      return new Date(Date.UTC(j, monat - 1, tag));
    }

    var cache = {};
    function feiertage(j) {
      if (cache[j]) return cache[j];
      var o = ostersonntag(j), s = {};
      function add(d) { s[iso(d)] = true; }
      add(new Date(Date.UTC(j, 0, 1)));    // Neujahr
      add(plus(o, -2));                    // Karfreitag
      add(plus(o, 1));                     // Ostermontag
      add(new Date(Date.UTC(j, 4, 1)));    // Tag der Arbeit
      add(plus(o, 39));                    // Christi Himmelfahrt
      add(plus(o, 50));                    // Pfingstmontag
      add(new Date(Date.UTC(j, 9, 3)));    // Tag der Deutschen Einheit
      add(new Date(Date.UTC(j, 11, 25)));  // 1. Weihnachtstag
      add(new Date(Date.UTC(j, 11, 26)));  // 2. Weihnachtstag
      KONFIG.zusatzFrei.forEach(function (md) {
        var t = md.split('-');
        add(new Date(Date.UTC(j, (+t[0]) - 1, +t[1])));
      });
      cache[j] = s;
      return s;
    }

    function frei(d)       { return !!feiertage(d.getUTCFullYear())[iso(d)]; }
    function versandTag(d) { return KONFIG.versandtage.indexOf(d.getUTCDay()) !== -1 && !frei(d); }
    function zustellTag(d) { return KONFIG.zustelltage.indexOf(d.getUTCDay()) !== -1 && !frei(d); }

    function berlin() {
      var p = {};
      new Intl.DateTimeFormat('en-CA', {
        timeZone: 'Europe/Berlin', year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false
      }).formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
      return {
        d: new Date(Date.UTC(+p.year, +p.month - 1, +p.day)),
        sek: (+p.hour) * 3600 + (+p.minute) * 60 + (+p.second)
      };
    }

    function naechsterVersand(d) {
      var x = plus(d, 1), i = 0;
      while (!versandTag(x) && i++ < 40) x = plus(x, 1);
      return x;
    }
    function plusZustell(d, n) {
      var x = d, i = 0;
      while (n > 0 && i++ < 60) { x = plus(x, 1); if (zustellTag(x)) n--; }
      return x;
    }
    function datumText(d) {
      return WT[d.getUTCDay()] + ', ' + d.getUTCDate() + '. ' + MO[d.getUTCMonth()];
    }

    function zeichne() {
      var teile = KONFIG.cutoff.split(':');
      var cutSek = ((parseInt(teile[0], 10) || 14) * 3600) + ((parseInt(teile[1], 10) || 0) * 60);

      var jetzt = berlin();
      var heuteVersand = versandTag(jetzt.d);
      var rest = cutSek - jetzt.sek;

      var versand = (heuteVersand && rest > 0) ? jetzt.d : naechsterVersand(jetzt.d);
      var von = plusZustell(versand, KONFIG.lieferzeitMin);
      var bis = plusZustell(versand, KONFIG.lieferzeitMax);

      var ziel = (iso(von) === iso(bis))
        ? '<b>' + datumText(bis) + '</b>'
        : '<b>' + datumText(von) + '</b> bis <b>' + datumText(bis) + '</b>';

      if (heuteVersand && rest > 0) {
        var std = Math.floor(rest / 3600);
        var min = Math.floor((rest % 3600) / 60);
        var uhr = std > 0 ? (std + ' Std ' + min + ' Min') : (min + ' Min');
        box.innerHTML = 'Bestellen Sie in den nächsten <b>' + uhr + '</b>, dann ist Ihre Lieferung voraussichtlich am ' + ziel + ' bei Ihnen.';
      } else {
        box.innerHTML = 'Ihre Lieferung ist voraussichtlich am ' + ziel + ' bei Ihnen.';
      }
    }

    zeichne();
    setInterval(zeichne, 20000);
  })();

  /* ===== M-Abo · Kaufoption (Erstbehandlung / Saison-Abo / Jahresabo) ===== */
  (function () {
    document.querySelectorAll('.pdp-abo').forEach(function (box) {
      if (box.dataset.ready) return;
      box.dataset.ready = '1';

      var daten  = {};
      var quelle = box.querySelector('.pdp-abo__daten');
      try { daten = JSON.parse((quelle && quelle.textContent) || '{}'); } catch (e) { daten = {}; }

      var ids = Object.keys(daten);
      if (!ids.length) { box.style.display = 'none'; return; }

      var optionen = [].slice.call(box.querySelectorAll('.pdp-abo__opt'));
      var fuss     = box.querySelector('[data-rolle="fuss"]');
      var aktiv    = '';
      var letzteId = '';

      function eur(cent) { return (cent / 100).toFixed(2).replace('.', ',') + ' €'; }

      /* ---- Naechster Liefertermin, inklusive Karenzzeit ----
         Termine und Karenztage stehen als data-Attribute am Modul und
         muessen mit den festen Zeitplaenen in Seal uebereinstimmen. */
      var MONATE = ['Januar','Februar','März','April','Mai','Juni','Juli',
                    'August','September','Oktober','November','Dezember'];

      function heuteBerlin() {
        var p = {};
        new Intl.DateTimeFormat('en-CA', {
          timeZone: 'Europe/Berlin', year: 'numeric', month: '2-digit', day: '2-digit'
        }).formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
        return new Date(Date.UTC(+p.year, +p.month - 1, +p.day));
      }

      function naechsterTermin(tage, karenz) {
        var heute  = heuteBerlin();
        var grenze = new Date(heute.getTime() + karenz * 86400000);
        var j0     = heute.getUTCFullYear();
        for (var j = j0; j <= j0 + 4; j++) {
          for (var i = 0; i < tage.length; i++) {
            var t = String(tage[i]).trim().split('-');
            var d = new Date(Date.UTC(j, (+t[0]) - 1, +t[1]));
            if (d > grenze) return d;
          }
        }
        return null;
      }

      function datumText(d) {
        return d.getUTCDate() + '. ' + MONATE[d.getUTCMonth()] + ' ' + d.getUTCFullYear();
      }

      function zeigeTermin(opt) {
        if (!opt.dataset.plan) return;
        var jahr  = opt.dataset.frei === '1';
        var tage  = (jahr ? box.dataset.jahrTage   : box.dataset.saisonTage)
                    || (jahr ? '03-15' : '03-15,05-15,07-15');
        var kar   = parseInt(jahr ? box.dataset.jahrKarenz : box.dataset.saisonKarenz, 10)
                    || (jahr ? 120 : 30);
        var d = naechsterTermin(tage.split(','), kar);
        if (!d) return;

        var el = opt.querySelector('[data-rolle="termin"]');
        if (!el) {
          el = document.createElement('span');
          el.className = 'pdp-abo__termin';
          el.setAttribute('data-rolle', 'termin');
          var body = opt.querySelector('.pdp-abo__body');
          if (!body) return;
          body.appendChild(el);
        }
        el.textContent = 'Ihre erste Lieferung geht sofort raus – die nächste am '
                       + datumText(d) + '.';
      }

      /* Mengen kommen aus dem Rechner: start = Erstbehandlung und Saison-Abo
         je Lieferung, saison = komplette Saisonmenge fuer das Jahresabo. */
      var mengen = null, gesetzt = null, letzteFormMenge = 0;

      function formMenge() {
        var f = hauptForm();
        var q = f && f.querySelector('input[name="quantity"]');
        var z = q ? parseInt(q.value, 10) : 1;
        return z > 0 ? z : 1;
      }

      /* Sobald der Kunde die Menge selbst anfasst, gilt seine Zahl fuer alle
         Zeilen. Vorher schlagen wir je Kaufoption die passende Menge vor. */
      function nutzerBestimmt() {
        return !mengen || (gesetzt !== null && formMenge() !== gesetzt);
      }

      function rowMenge(opt) {
        if (nutzerBestimmt()) return formMenge();
        return opt.dataset.frei === '1' ? mengen.saison : mengen.start;
      }

      function zeigeAnzahl(opt, z) {
        var body = opt.querySelector('.pdp-abo__body');
        if (!body) return;
        var el = opt.querySelector('[data-rolle="anz"]');
        if (!el) {
          el = document.createElement('span');
          el.className = 'pdp-abo__anz';
          el.setAttribute('data-rolle', 'anz');
          var txt = opt.querySelector('.pdp-abo__text');
          if (txt) body.insertBefore(el, txt); else body.appendChild(el);
        }
        if (!mengen && z === 1) { el.hidden = true; return; }

        var jeLieferung = opt.dataset.plan && opt.dataset.frei !== '1';
        el.textContent = z + (z === 1 ? ' Dose' : ' Dosen') + (jeLieferung ? ' je Lieferung' : '');
        el.hidden = false;
      }

      /* Menge ins Formular schreiben - aber nur, solange der Kunde sie nicht
         selbst angefasst hat. Danach gehoert sie ihm. */
      function schreibeMenge() {
        if (!mengen) return;
        var f = hauptForm();
        var q = f && f.querySelector('input[name="quantity"]');
        if (!q) return;
        var opt = optionen.filter(function (o) { return (o.dataset.plan || '') === aktiv; })[0];
        var z = opt ? rowMenge(opt) : mengen.start;
        var jetzt = parseInt(q.value, 10) || 1;
        if (gesetzt !== null && jetzt !== gesetzt) return;
        if (jetzt === z) { gesetzt = z; return; }
        q.value = z; gesetzt = z;
        q.dispatchEvent(new Event('input',  { bubbles: true }));
        q.dispatchEvent(new Event('change', { bubbles: true }));
      }

      /* Das Hauptformular ist jenes, dessen id-Feld eine Variante DIESES Produkts
         traegt. Auf der Seite liegen ueber zehn Warenkorbformulare (Cross-Sells). */
      function hauptForm() {
        var formulare = document.querySelectorAll('form[action*="/cart/add"]');
        for (var i = 0; i < formulare.length; i++) {
          var idf = formulare[i].querySelector('[name="id"]');
          if (idf && ids.indexOf(String(idf.value).trim()) >= 0) return formulare[i];
        }
        var onv = document.querySelector('[option-name-value]');
        return (onv && onv.closest('form')) || null;
      }

      function variantenId() {
        var f   = hauptForm();
        var idf = f && f.querySelector('[name="id"]');
        var v   = idf ? String(idf.value).trim() : '';
        return daten[v] ? v : ids[0];
      }

      /* Bei der Erstbehandlung wird das Feld deaktiviert, damit ein leeres
         selling_plan gar nicht mitgesendet wird - sonst antwortet Shopify mit 422. */
      function schreibe() {
        var f = hauptForm(); if (!f) return;
        var inp = f.querySelector('input[name="selling_plan"]');
        if (!inp) {
          inp = document.createElement('input');
          inp.type = 'hidden';
          inp.name = 'selling_plan';
          f.appendChild(inp);
        }
        if (aktiv) { inp.value = aktiv; inp.disabled = false; }
        else       { inp.value = '';    inp.disabled = true;  }
      }

      function markiere() {
        optionen.forEach(function (opt) {
          var an = (opt.dataset.plan || '') === aktiv;
          opt.classList.toggle('is-on', an);
          var r = opt.querySelector('input[type="radio"]');
          if (r) r.checked = an;
        });
      }

      function zeigeFuss() {
        if (!fuss) return;
        if (!aktiv) { fuss.hidden = true; return; }
        var opt = optionen.filter(function (o) { return o.dataset.plan === aktiv; })[0];
        fuss.textContent = (opt && opt.dataset.frei === '1')
          ? 'Jederzeit kündbar. Belastet wird erst am jeweiligen Liefertermin.'
          : 'Versandkosten fallen je Lieferung an. Jederzeit kündbar.';
        fuss.hidden = false;
      }

      function waehle(pid) {
        aktiv = pid || '';
        markiere();
        schreibe();
        zeigeFuss();
        var o = optionen.filter(function (x) { return x.dataset.plan === aktiv; })[0];
        var art = !aktiv ? 'einmal' : (o && o.dataset.frei === '1' ? 'jahr' : 'saison');
        document.documentElement.setAttribute('data-pdp-kaufoption', art);
        document.dispatchEvent(new CustomEvent('pdp:kaufoption', { detail: { art: art, plan: aktiv } }));
        schreibeMenge();
        preisSyncen();
      }

      function zeichne() {
        var v = daten[variantenId()];
        if (!v) return;
        var aktivSichtbar = false;

        optionen.forEach(function (opt) {
          var pid  = opt.dataset.plan || '';
          var cent = pid ? (v.plaene ? v.plaene[pid] : null) : v.basis;
          var da   = (cent !== null && cent !== undefined);

          var istSaison = pid && opt.dataset.frei !== '1';
          if (pid) opt.hidden = !da || (istSaison && mengen && mengen.saisonAbo === false);
          if (opt.hidden || !da) return;
          opt.dataset.cent = cent;
          var anzahl = rowMenge(opt);
          zeigeAnzahl(opt, anzahl);

          var pel = opt.querySelector('.pdp-abo__preis');
          if (pel) pel.textContent = eur(cent * anzahl);

          var bel = opt.querySelector('.pdp-abo__badge');
          if (bel) {
            var p = v.basis > 0 ? Math.round((1 - cent / v.basis) * 100) : 0;
            if (p > 0) { bel.textContent = '−' + p + ' %'; bel.hidden = false; }
            else bel.hidden = true;
          }

          var jel = opt.querySelector('[data-rolle="jetzt"]');
          if (jel) {
            jel.textContent = 'Heute zahlen Sie nur ' + eur(cent * anzahl)
              + ' – jede weitere Lieferung wird erst zu ihrem Termin berechnet.';
          }
          zeigeTermin(opt);

          if (pid === aktiv) aktivSichtbar = true;
        });

        if (aktiv && !aktivSichtbar) waehle('');
        preisSyncen();
      }

      /* ---- Grosse Preisanzeige des Themes mitziehen ----
         GemPages rechnet dort nur Menge x Einmalpreis. Sobald ein Abo gewaehlt
         ist, stimmt diese Zahl nicht mehr - also schreiben wir sie selbst. */
      function preisFeld() {
        var raum = box.closest('gp-product') || hauptForm() || document;
        return raum.querySelector('.gp-price.gp-money:not(.gp-product-compare-price)')
            || document.querySelector('.gp-price.gp-money:not(.gp-product-compare-price)');
      }

      function wieVorlage(vorlage, cent) {
        var zahl = (cent / 100).toFixed(2).replace('.', ',');
        return /^\s*€/.test(vorlage || '') ? '€' + zahl : zahl + ' €';
      }

      function preisSyncen() {
        var el = preisFeld(); if (!el) return;
        var v = daten[variantenId()]; if (!v) return;
        var opt = optionen.filter(function (o) { return (o.dataset.plan || '') === aktiv; })[0];
        if (!opt || opt.hidden) return;
        var cent = aktiv ? (v.plaene || {})[aktiv] : v.basis;
        if (cent === null || cent === undefined) return;
        var neu = wieVorlage(el.textContent, cent * rowMenge(opt));
        if (el.textContent.trim() !== neu) el.textContent = neu;
      }

      function pruefe() {
        var vid = variantenId(), mg = formMenge();
        if (vid !== letzteId || mg !== letzteFormMenge) {
          letzteId = vid; letzteFormMenge = mg; zeichne();
        }
        preisSyncen();
        schreibe();
      }

      optionen.forEach(function (opt) {
        opt.addEventListener('click', function () { waehle(opt.dataset.plan || ''); });
        var r = opt.querySelector('input[type="radio"]');
        if (r) r.addEventListener('change', function () {
          if (r.checked) waehle(opt.dataset.plan || '');
        });
      });

      var form = hauptForm();
      if (form) {
        form.addEventListener('submit', function () { schreibe(); }, true);
        form.addEventListener('change', pruefe, true);
      }

      document.addEventListener('pointerdown', function (ev) {
        var f = hauptForm();
        if (f && ev.target && f.contains(ev.target)) schreibe();
      }, true);

      document.addEventListener('pdp:mengen', function (ev) {
        mengen = ev.detail;
        /* Wer das Teichvolumen anfasst, fragt nach einer Empfehlung - also
           uebernehmen wir die Menge wieder, auch nach einer Handeingabe. */
        gesetzt = null;
        zeichne();
        schreibeMenge();
      });

      letzteId = variantenId();
      waehle('');
      zeichne();
      setInterval(pruefe, 500);
    });
  })();

}